export default __webpack_public_path__ + "media/images/work_with_us/team-pic-2-1d5a10a3cf0cd7d3493002c57086480e.png";